import React from 'react';
import axios from 'axios';
import ApiEndpoints from '../const/ApiEndpoints';
// import SwalToast  from '../components/Common/SwalToast';

/**
 * Custom hook for managing color palettes and preferences.
 *
 * @param {Object} initialState - Initial state for the hook.
 * @param {string} initialState.column - The selected column.
 * @param {Object} initialState.color - The color preferences.
 * @param {Object} initialState.hexCodes - Hex color codes.
 * @returns {{
 *   hexCodes: Object.<string, string>,
 *   sethexCodes: React.Dispatch<React.SetStateAction<Object.<string, string>>>,
 *   selectColumn: string,
 *   setselectedColumn: React.Dispatch<React.SetStateAction<string>>,
 *   selectColumnHelper: (column: string) => void,
 *   color: { background: string },
 *   setcolor: React.Dispatch<React.SetStateAction<{ background: string }>>,
 *   graphSetting: (body: Object) => Promise<any>,
 *   fetchGraphColor: (module: string) => Promise<any>
 * }} Object containing state variables and functions of color palettes.
 * @throws {Error} Throws an error if color preferences cannot be fetched.
 */
export default function useCustomTheme() {
  const [hexCodes, sethexCodes] = React.useState({});
  const [selectColumn, setselectedColumn] = React.useState('');
  const [color, setcolor] = React.useState({ background: 'fff' });

  const saveTheme = (id, body) => {
    return axios
      .post(
        `${ApiEndpoints.BASE_URL + ApiEndpoints.POST_THEME_PRODUCT}`,
        body,
        {
          headers: {
            'X-Tenant-ID': id,
          },
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  };

  /**
   * @function fetchThemeConfiguration
   * @name fetchThemeConfiguration - Fetches the theme of the product
   * @param {string} id - The ID of the organization.
   * @returns {Promise<Object>} A promise that resolves with the response from the server or rejects with an error.
   */
  const fetchThemeConfiguration = (id, product, theme) => {
    return axios
      .get(`${ApiEndpoints.BASE_URL + ApiEndpoints.GET_THEME_PRODUCT}`, {
        headers: {
          'X-Tenant-ID': id,
        },
        params: {
          product,
          theme,
        },
      })
      .then(
        (res) => {
          return res;
        },
        (error) => {
          throw error;
        }
      );
  };
  const saveThemeMode = (body) => {
    return axios
      .post(
        `${
          ApiEndpoints.MODULE_BASE_URL.DI +
          ApiEndpoints.PROJECT_MANAGEMENT.SAVE_THEME_MODE
        }`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  };
  const resetToDefaultTheme = (id, body) => {
    return axios
      .post(
        `${ApiEndpoints.BASE_URL + ApiEndpoints.DEFAULT_THEME_PRODUCT}`,
        body,
        {
          headers: {
            'X-Tenant-ID': id,
          },
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  };
  return {
    hexCodes,
    sethexCodes,
    selectColumn,
    setselectedColumn,
    // selectColumnHelper,
    color,
    // resetGraphSetting,
    setcolor,
    // graphSetting,
    // fetchGraphColor,
    saveTheme,
    fetchThemeConfiguration,
    saveThemeMode,
    resetToDefaultTheme,
  };
}
